export default function Footer() {
  const scrollToSection = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '专题索引', href: '#index' },
        { label: '热门榜单', href: '#ranking' },
      ],
    },
    {
      title: '平台服务',
      links: [
        { label: '平台特色', href: '#features' },
        { label: '精选推荐', href: '#cards' },
        { label: '移动端入口', href: '#app' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="w-full bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('#hero');
              }}
              className="text-2xl font-heading text-white whitespace-nowrap cursor-pointer"
            >
              妖精动漫
            </a>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed max-w-[280px]">
              妖精动漫网 — 免费在线看韩漫、日漫、国漫全集。下拉式阅读，追更收藏一站搞定，每日更新热门连载。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#hero');
                }}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-accent-400 hover:bg-background-700 cursor-pointer transition-colors"
                aria-label="首页"
              >
                <i className="ri-home-4-line"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 cursor-default">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 cursor-default">
                <i className="ri-weibo-line"></i>
              </span>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{group.title}</h4>
              {group.links.length > 0 ? (
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToSection(link.href);
                        }}
                        className="text-sm text-foreground-400 hover:text-accent-400 cursor-pointer transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-500">敬请期待</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 妖精动漫网. 本站所有漫画资源仅供学习交流使用。
          </p>
          <p className="text-xs text-foreground-600">
            妖精动漫官网入口 · 安全稳定的漫画阅读平台
          </p>
        </div>
      </div>
    </footer>
  );
}